module.exports = __webpack_public_path__ + "static/media/Shonen.3dd8bdb9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/UI/musicButton/song/Shonen.mp3
// module id = 908
// module chunks = 0